export default __webpack_public_path__ + "static/2-d6d283086006fb6550007bf545dcd47e.png";